import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'antd';

import help1 from '../../imgs/help1.png';
import help2 from '../../imgs/help2.png';
import help3 from '../../imgs/help3.png';
import jfCode from '../../imgs/jfCode.jpg';

const ConnectService = props => {
  return (
    <Modal
      title="联系客服"
      centered
      visible={props.visible}
      onCancel={() => props.onCancel()}
      destroyOnClose={true}
      width={600}
      className="help-dialog"
      footer={null}
    >
      <div className="helpBox">
        <div className="helpContent">
          <div className="helpBody">
            <div>
              <div className="helpItem">
                <img alt="" src={help1} />
                <div>
                  <p>全国免费热线</p>
                  <p>400-886-9793</p>
                  <p>025-52232290</p>
                </div>
              </div>
              <div className="helpItem">
                <img alt="" src={help2} />
                <div>
                  <p>工作时间</p>
                  <p>周一至周五 08:30--17:30</p>
                </div>
              </div>
              <div className="helpItem">
                <img alt="" src={help3} />
                <div>
                  <p>客服微信号</p>
                  <p>jfylsh</p>
                </div>
              </div>
            </div>
            <div className="jf-code">
              <img alt="" src={jfCode} />
              <div style={{ textAlign: 'center' }}>扫一扫</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
ConnectService.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default ConnectService;
